import { Component, type ReactNode } from 'react'
import { Button, Result } from 'antd'

export class RouteErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() { return { failed: true } }

  render() {
    if (!this.state.failed) return this.props.children
    return <Result status="warning" title="页面暂时无法打开" subTitle="页面可能已更新，或网络暂时不可用。请重新加载后继续。" extra={<Button type="primary" onClick={() => window.location.reload()}>重新加载</Button>} />
  }
}
